import React from "react";
import { Col, Form, Modal, Button, Row } from "react-bootstrap";
import { FiMail } from 'react-icons/fi';
import PropTypes from 'prop-types';
import useToken from "hooks/useToken";
import { useToast } from 'context/providers/ToastProvider';
import { generateSurveyEmailHtml } from "utils/emailTemplates";

const ModalEnviarEncuesta = ({
    showModal,
    setShowModal,
    comentario,
    emailCliente,
    setComentarios
}) => {
    const { token } = useToken();
    const { showErrorToast, showSuccessToast } = useToast();

    // Function to encode UTF-8 string to base64
    const utf8_to_b64 = (str) => {
        return btoa(unescape(encodeURIComponent(str)));
    };

    const getHtmlContent = () => {
        return generateSurveyEmailHtml(comentario);
    };

    const handleEnviarEncuesta = () => {
        const htmlContent = getHtmlContent();
        const encodedHtml = utf8_to_b64(htmlContent);
        fetch('/api/soportetecnico/enviarEncuesta', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                html: encodedHtml,
                email: emailCliente,
                idClientesAkasiaComentariosProblema: comentario.idClientesAkasiaComentariosProblema
            })
        })
            .then(response => response.json())
            .then(data => {
                if (data.iResponseType === 1) {
                    showSuccessToast("Encuesta enviada exitosamente al cliente");
                    setShowModal(false);
                    if (data.detalles && setComentarios) {
                        const updatedData = JSON.parse(data.detalles)[0];
                        setComentarios(prev => prev.map(c => c.idClientesAkasiaComentariosProblema === updatedData.idClientesAkasiaComentariosProblema ? {...c, vCorreoElectronicoEncuesta: updatedData.vCorreoElectronicoEncuesta} : c));
                    }
                } else {
                    showErrorToast(data.vMessage || "Error al enviar la encuesta");
                }
            })
            .catch(error => {
                showErrorToast("Error al enviar la encuesta: " + error.message);
            });
    };

    return (
        <Modal show={showModal} onHide={() => setShowModal(false)} centered size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Enviar Encuesta por E-mail</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col md={6}>
                        <Form.Group>
                            <Form.Label><strong>Correo electr�nico del cliente:</strong></Form.Label>
                            <Form.Control
                                type="email"
                                value={emailCliente || ''}
                                readOnly
                                placeholder="No disponible"
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row className="mt-3">
                    <Col>
                        <Form.Label><strong>Vista previa del mensaje:</strong></Form.Label>
                        <div style={{
                            border: '1px solid #ddd',
                            padding: '15px',
                            backgroundColor: '#f9f9f9',
                            borderRadius: '5px',
                            fontFamily: 'Arial, sans-serif',
                            lineHeight: '1.6'
                        }}>
                            <div dangerouslySetInnerHTML={{
                                __html: getHtmlContent()
                            }} />
                        </div>
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowModal(false)}>
                    Cancelar
                </Button>
                <Button variant="primary" onClick={handleEnviarEncuesta}>
                    <FiMail className="me-2" />
                    Enviar Encuesta
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

ModalEnviarEncuesta.propTypes = {
    showModal: PropTypes.bool.isRequired,
    setShowModal: PropTypes.func.isRequired,
    comentario: PropTypes.object.isRequired,
    emailCliente: PropTypes.string,
    setComentarios: PropTypes.func.isRequired
};

export default ModalEnviarEncuesta;